import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerChecklist, BOX_IMAGE, CHECKOUT_URL } from '../data/content';
import { CTAButton, TrustLine } from './CTAButton';
export function Offer() {
  return <section id="comprar" className="scroll-mt-2 bg-white px-4 py-5 sm:px-6" data-id="element-115" data-mp="1mnscei9wcob6">
      <div className="mx-auto max-w-lg" data-id="element-116" data-mp="1hopi9svgg2hz">
        <p className="text-center font-heading text-[0.7rem] font-extrabold uppercase tracking-[0.2em] text-turq sm:text-sm" data-id="element-117" data-mp="1hpqrdrswuex2">
          Special Launch Offer
        </p>
        <div className="mt-1.5 rounded-2xl border-2 border-turq bg-ice p-3.5 shadow-lg" data-id="element-118" data-mp="p0a1p1wodc4j">
          <h2 className="text-center font-heading text-lg font-extrabold uppercase text-deep sm:text-2xl" data-id="element-119" data-mp="13wrb3nlb0gog">
            👁️ Ophthalmology Visual Atlas™
          </h2>
          <p className="text-center font-heading text-[0.72rem] font-semibold uppercase tracking-wide text-ink sm:text-sm" data-id="element-120" data-mp="z0119i03ehbh">
            The Complete Visual Study System for Ophthalmology
          </p>

          <a href={CHECKOUT_URL} rel="noopener" className="mt-2 block" data-id="element-121" data-mp="2af7kkroctzuc">
            <img src={BOX_IMAGE} alt="OPHTHALMOLOGY VISUAL ATLAS™ complete 6-in-1 system" className="mx-auto w-full max-w-[190px]" data-id="element-122" data-mp="pjp9xxd4gsoc" />
          </a>

          <p className="mt-1 text-center font-heading text-[0.8rem] font-bold uppercase text-turq" data-id="element-123" data-mp="ziwlqg47kf9c">
            Complete 6-in-1 System
          </p>

          <ul className="mt-2 space-y-0.5" data-id="element-124" data-mp="6tzink8kip16">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-2" data-id="element-125" data-mp="bstzwhqw05j6">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-turq" strokeWidth={3} aria-hidden="true" data-id="element-126" data-mp="bt2a21vmkwqo" />
                <span className="text-[0.86rem] leading-snug text-ink sm:text-base" data-id="element-127" data-mp="klxit5kaxal7">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mt-3 text-center font-heading text-base font-extrabold uppercase leading-tight text-deep sm:text-xl" data-id="element-128" data-mp="3o9fo3lefzdue">
            🔥 Get Ophthalmology Visual Atlas™ today
          </p>
          <p className="text-center font-heading text-4xl font-extrabold text-turq sm:text-5xl" data-id="element-129" data-mp="qhfn7rcq129z">
            $26.90
          </p>

          <div className="mt-2.5" data-id="element-130" data-mp="1550pxk5oozhd">
            <CTAButton label="👁️ Get instant access" sub="Immediate Digital Access" target="checkout" data-id="element-131" data-mp="157d7vxbfz9uf" />
          </div>
          <TrustLine className="mt-2" data-id="element-132" data-mp="ch4tmgk119l4" />
        </div>
      </div>
    </section>;
}